import { Component, Input, OnInit } from '@angular/core';

import {PageHelper, PageNode, Site} from '../../common/services';

@Component({
  selector: 'p8-bdc-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  @Input() site: Site;
  pages: PageNode[];
  constructor(private pageHelper: PageHelper) { }

  ngOnInit() {
    if (this.site) {
      this.pages = [...this.site.pages.children];
      this.pageHelper.sortPages(this.pages);
    }
  }

  getMainCategories(): PageNode[] {
    return this.pages.filter((_page) => _page.data.is_published);
  }
}
